<template>
    <q-select
        outlined
        :model-value="numericValue"
        :label="label"
        @update:model-value="$emit('update:modelValue', $event)"
        :options="options"
        :error="error"
        :loading="loading"
        hide-bottom-space
        map-options
        emit-value
    >
        <template #no-option>
            <q-item>
                <q-item-section class="text-grey"> No results </q-item-section>
            </q-item>
        </template>
        <template #error>
            <span v-for="err in errors" :key="err">{{ err }}</span>
        </template>
    </q-select>
</template>

<script setup>
import { computed, ref } from "vue";
import { useDefaultDataStore } from "@/stores/useDefaultDataStore";

const defaultDataStore = useDefaultDataStore();
const props = defineProps({
    modelValue: {
        type: [String, Number],
        default: 1,
    },
    errors: [String, Array],
    label: {
        type: String,
        default: "Alícuota",
    },
    tipo: [String],
});
defineEmits(["update:modelValue"]);
const options = computed(() => defaultDataStore?.getAlicuotas || []);
const numericValue = computed(() => props.modelValue !== null && props.modelValue !== undefined ? Number(props.modelValue) : null);
const error = computed(() => props?.errors && props?.errors?.length !== 0);
const loading = ref(false);
</script>
